module.exports = __webpack_public_path__ + "img/offeo-5.d613a560.png";